// Cookie Constants
export const COOKIE_CART_ID = "ecom_cartId"
export const COOKIE_ACCESS_TOKEN = "ecom_accessToken"
export const COOKIE_FAVORITES = "ecom_favorites"

// Tags
export const TAGS = {
  CART: "cart",
} as const

// Buckets
export const BUCKETS = {
  HOME: ["a", "b"],
} as const

// F Parameters
export const F_PARAMS = [
  "q",
  "minPrice",
  "maxPrice",
  "sortBy",
  "categories",
  "vendors",
  "tags",
  "colors",
  "sizes",
  "rating",
] as const

// Hierarchical Attributes
export const HIERARCHICAL_ATRIBUTES = [
  "hierarchicalCategories.lvl0",
  "hierarchicalCategories.lvl1",
  "hierarchicalCategories.lvl2",
] as const

// Miscellaneous Constants
export const HIERARCHICAL_SEPARATOR = " > "
export const HITS_PER_PAGE = 241

export const CATEGORIES = [
  { id: "ed", label: "Education" },
  { id: "bu", label: "Business" },
  { id: "inf", label: "Information" },
  { id: "int", label: "Interview" },
  { id: "tra", label: "Travel" },
  { id: "job", label: "Jobs" },
  { id: "fas", label: "Fashion" },
  { id: "sem", label: "Seminars" },
  { id: "conf", label: "Conference" },
  { id: "event", label: "Events" },
]

export const CATEGORIES_AMHARIC = [
  { id: "ed", label: "ትምህርት" },
  { id: "bu", label: "ንግድ" },
  { id: "inf", label: "መረጃ" },
  { id: "int", label: "ቃለ መጠይቅ" },
  { id: "tra", label: "ጉዞ" },
  { id: "job", label: "ሥራ" },
  { id: "fas", label: "ፋሽን" },
  { id: "sem", label: "ሰሚናር" },
  { id: "conf", label: "ውይይት" },
  { id: "event", label: "ክስተቶች" },
]


export enum JobType {
  "FULL-TIME" = "full-time",
  "PART-TIME" = "part-time",
  "CONTRACT" = "contract",
  "TEMPORARY" = "temporary",
  "INTERN" = "intern",
  "VOLUNTEER" = "volunteer"
}

export enum ExperienceLevel {
  "SENIOR" = "senior",
  "JUNIOR" = "junior",
  "MID-SENIOR" = "mid-senior",
  "EXPERT" = "expert",
}
